module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contract-page margin-top-20 ",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [
    [_c('div', {
      staticClass: "vtb-list"
    }, [_vm._l((_vm.vtbList), function(item, index) {
      return [_c('div', {
        staticClass: "vtb-item",
        class: {
          'vtb-item-active': _vm.vtbIndex == index
        },
        on: {
          "click": function($event) {
            return _vm.clickvtb(index)
          }
        }
      }, [_vm._v("\n          " + _vm._s(item.title) + " "), (index != 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.getNum(item.id)) + ")")]) : _vm._e()])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "padding-left-10 padding-right-10"
    }, [_vm._m(0), _vm._v(" "), (_vm.list) ? _c('div', {
      staticClass: "tab-content"
    }, [_vm._l((_vm.list), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "box5"
      }, [_c('div', {
        staticClass: "tab-content-item"
      }, [_c('div', {
        staticClass: "contactItem",
        class: 'icon0' + item.contactType
      }), _vm._v(" "), _c('div', {
        staticClass: "margin-left-15"
      }, [_c('div', {
        staticClass: "flex aligin-center"
      }, [(item.recommend == '1') ? _c('el-tag', {
        staticClass: "margin-right-10",
        attrs: {
          "type": "danger",
          "effect": "dark",
          "size": "mini"
        }
      }, [_vm._v("推荐\n                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.contactDetail))])], 1), _vm._v(" "), _c('div', {
        staticClass: "margin-top-5"
      }, [_vm._v("联系人：" + _vm._s(item.contactPerson || "--") + "," + _vm._s(item.contactPosition || "") + "\n              ")])])]), _vm._v(" "), _c('div', {
        staticClass: "tab-content-item"
      }, [(item.contactPosition) ? _c('el-tag', {
        staticClass: "margin-right-10",
        attrs: {
          "effect": "dark",
          "size": "small"
        }
      }, [_vm._v("\n              " + _vm._s(item.contactPosition || "") + "\n            ")]) : _c('span', [_vm._v(" --")])], 1)])
    }), _vm._v(" "), (!_vm.list.length) ? _c('div', {
      staticClass: "padding-bottom-40"
    }, [_c('nomore')], 1) : _vm._e()], 2) : _c('div', {
      staticClass: "padding-bottom-40"
    }, [_c('nomore')], 1), _vm._v(" "), _c('div', {
      staticClass: "text-right",
      staticStyle: {
        "padding": "20px 0"
      }
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "page-size": _vm.pagesize,
        "hide-on-single-page": false,
        "page-sizes": _vm.pageSizes,
        "layout": "prev, pager, next,sizes",
        "current-page": _vm.currentPage,
        "total": _vm.totalnum
      },
      on: {
        "size-change": _vm.handleSizeChange,
        "current-change": function($event) {
          return _vm.handleCurrentChange($event, 0)
        }
      }
    })], 1)])]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-header"
  }, [_c('div', {
    staticClass: "tab-header-item"
  }, [_vm._v("联系方式信息")]), _vm._v(" "), _c('div', {
    staticClass: "tab-header-item"
  }, [_vm._v("职务标签")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38dd8cd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/contract-page.vue
// module id = 888
// module chunks = 1